module.exports = __webpack_public_path__ + "img/1intro-1_ergebnis.7f721643.png";